export default {
  NETWORK_ERROR: '网络错误',
  VALIDATION: '校验错误',
  SESSION_EXPIRE: '请先登陆会员'
}



// WEBPACK FOOTER //
// ./src/constants/errors.js